module.exports = "## Select Field\n\nTo learn more about `SelectField` please visit the specifications\n[here](https://www.google.com/design/spec/components/menus.html#menus-usage).\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/SelectField/README.md
 ** module id = 1045
 ** module chunks = 0
 **/